import { UserActionType } from '@wix/ambassador-funnel-chatbot-v1-session/types';

import { MESSAGES } from '../../constants';
import { getLast } from '../../util/guards';
import { TRootState } from '../reducers';
import {
  ChatScrollTo,
  IUserAction,
  RestartChatParameters,
  TItem,
} from '../reducers/types';

export const selectItems = (state: TRootState): TItem[] => {
  return state.chat.items;
};

export const selectItemsLength = (state: TRootState): number => {
  return selectItems(state).length;
};

export const selectLastItem = (state: TRootState): TItem | undefined => {
  return getLast(state.chat.items);
};

export const selectUnreadCount = (state: TRootState): number => {
  return state.chat.unreadCount;
};

export const selectIsLiveChat = (state: TRootState): boolean => {
  return state.chat.isLiveChat;
};

export const selectIsMuted = (state: TRootState): boolean => {
  return state.chat.isMuted;
};

export const selectIsLocked = (state: TRootState): boolean => {
  return state.chat.isLocked;
};

export const selectConversationId = (state: TRootState): string | undefined => {
  return state.chat.conversationId;
};

export const selectBiData = (state: TRootState) =>
  <const>{
    conversation_id: selectConversationId(state),
    nodeId: state.field.nodeId,
    intentId: state.meta.intentId,
    mainOptionName: state.meta.mainOptionName,
  };

export const selectUndelivered = (id: string) => {
  return (state: TRootState): IUserAction | UserActionType | undefined => {
    return state.chat.undelivered[id];
  };
};

export const selectScrollTo = (state: TRootState): ChatScrollTo | undefined => {
  return state.chat.scrollTo;
};

export const selectRestartChatParameters = (
  state: TRootState,
): RestartChatParameters | undefined => {
  return state.chat.restartChatParameters;
};

export const selectChatbotDataLoading = (
  state: TRootState,
): boolean | undefined => {
  return state.chat.chatbotDataLoading;
};

export const selectIsUserEngaged = (state: TRootState): boolean => {
  return Boolean(
    state.chat.items.find(({ type }) => type === MESSAGES.USER_MESSAGE),
  );
};
